<div class="gallery" :class="imageGalleryClass" ref="galleryWrapper">
    <div class="gallery__image-wrapper" v-for="(url, index) in imageGalleryOptions.images" ref="imageWrapper">
            <div class="gallery__spinner-wrapper" v-if="isLoading">
                <progress-spinner class="gallery__spinner"></progress-spinner>
            </div>
        <img :src="url" class="gallery__image"/>
        <div class="gallery__close-icon-wrapper">
            <mom-icon class="gallery__close-icon" svgIcon="close-fill-circle" @click.native="onCloseImage(index)"></mom-icon>
        </div>
    </div>
</div>
